import script from "./PaymentFailureBanner.vue?vue&type=script&lang=ts&setup=true"
export * from "./PaymentFailureBanner.vue?vue&type=script&lang=ts&setup=true"

import "./PaymentFailureBanner.vue?vue&type=style&index=0&id=407eaa70&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-407eaa70"]])

export default __exports__